import React, { Component } from 'react'
import cx from 'classnames'
import findIndex from 'lodash/findIndex'
import PropTypes from 'prop-types'

import { Button } from '@wf-common/atoms'
import Dialog from '../modal/dialog'
import ItemSourceDropdown from './item-source-dropdown'
import { availableSectionsPropType } from './props/available-sections-prop-type'
import { itemSourcesPropType } from './props/item-sources-prop-type'
import SectionsDropdown from './sections-dropdown'

import styles from './tag-section-editor.module.css'

const propTypes = {
    addButtonClassName: PropTypes.string,
    addButtonText: PropTypes.string.isRequired,
    availableSections: availableSectionsPropType.isRequired,
    availableSectionsDescription: PropTypes.string,
    cancelButtonClassName: PropTypes.string,
    cancelButtonText: PropTypes.string.isRequired,
    className: PropTypes.string,
    itemSources: itemSourcesPropType.isRequired,
    itemSourcesDescription: PropTypes.string,
    onAdd: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    sectionDropdownClassName: PropTypes.string,
    title: PropTypes.string.isRequired
}

const defaultProps = {
    availableSections: []
}

/**
 * This widget is part of <TagSectionEditor /> - see the docs there. It is not exposed to other outside use
 * Also see props.js for more info on the received propTypes
 */
class SelectionDialog extends Component {
    constructor(props) {
        super(props)
        this.onItemSelectedFromSource = this.onItemSelectedFromSource.bind(this)
        this.onSectionSelected = this.onSectionSelected.bind(this)
        this.onAdd = this.onAdd.bind(this)
        this.renderItemSource = this.renderItemSource.bind(this)
        this.state = {
            items: [],
            section: props.availableSections[0].id
        }
    }

    render() {
        const { className, title } = this.props
        return (
            <Dialog
                {...{ title }}
                className={cx(styles['dialog'], className, 't3sel-tag-section-editor-dialog')}
                message={
                    <div>
                        {this.renderItemSources()}
                        {this.renderSections()}
                    </div>
                }
            >
                {this.renderButtons()}
            </Dialog>
        )
    }

    renderItemSources() {
        const { itemSources, itemSourcesDescription } = this.props
        return (
            <div>
                <div className={styles['dialog-description']}>{itemSourcesDescription}</div>
                {itemSources.map(this.renderItemSource.bind(this))}
            </div>
        )
    }

    renderItemSource(itemSource) {
        const selectedItems = this.state.items.filter(item => item.sourceId === itemSource.id).map(item => item.itemId)

        return (
            <ItemSourceDropdown
                key={itemSource.id}
                onChange={this.onItemSelectedFromSource}
                {...{ itemSource, selectedItems }}
            />
        )
    }

    renderSections() {
        const { availableSections, availableSectionsDescription, sectionDropdownClassName } = this.props
        const selectedIndex = findIndex(availableSections, section => section.id === this.state.section) || 0
        return (
            <div>
                <div className={cx(styles['dialog-description'], styles['last'])}>{availableSectionsDescription}</div>
                <SectionsDropdown
                    className={sectionDropdownClassName}
                    onChange={this.onSectionSelected}
                    {...{ availableSections, selectedIndex }}
                />
            </div>
        )
    }

    renderButtons() {
        const { addButtonClassName, addButtonText, cancelButtonClassName, cancelButtonText, onCancel } = this.props
        return (
            <div className={styles['dialog-buttons']}>
                <Button
                    onClick={this.onAdd}
                    className={cx('t3sel-tag-section-editor-dialog-add-button', addButtonClassName)}
                    disabled={this.state.items.length === 0}
                    primary
                >
                    {addButtonText}
                </Button>
                <Button
                    onClick={onCancel}
                    className={cx('t3sel-tag-section-editor-dialog-cancel-button', cancelButtonClassName)}
                >
                    {cancelButtonText}
                </Button>
            </div>
        )
    }

    onAdd() {
        this.props.onAdd(this.state.section, this.state.items)
    }

    onItemSelectedFromSource(items, sourceId) {
        const newItems = this.state.items.filter(item => item.sourceId !== sourceId)
        this.setState({
            items: newItems.concat(items)
        })
    }

    onSectionSelected(id) {
        this.setState({
            section: id
        })
    }
}

SelectionDialog.propTypes = propTypes
SelectionDialog.defaultProps = defaultProps

export default SelectionDialog
